import type { UserInfo } from '../types/user'
import { apiRequest } from './apiClient'

type TokenResponse = { token?: string } | string

function parseToken(data: TokenResponse): string {
  if (typeof data === 'string' && data) return data
  if (data && typeof data === 'object' && data.token) return data.token
  throw new Error('Login failed')
}

export class AuthAPI {
  static getUserInfo(): Promise<UserInfo> {
    return apiRequest<UserInfo>('user/get_user_info')
  }

  static sendEmailCode(email: string): Promise<void> {
    return apiRequest('user/send_email_code', { method: 'POST', body: { email } })
  }

  static async emailRegister(email: string, password: string, code: string): Promise<{ token: string }> {
    const data = await apiRequest<TokenResponse>('user/email_register', {
      method: 'POST',
      body: { email, password, code },
    })
    return { token: parseToken(data) }
  }

  static async emailLogin(email: string, password: string): Promise<{ token: string }> {
    const data = await apiRequest<TokenResponse>('user/email_login', {
      method: 'POST',
      body: { email, password },
    })
    return { token: parseToken(data) }
  }

  static sendResetPasswordEmail(email: string): Promise<void> {
    return apiRequest('user/send_reset_password_email', { method: 'POST', body: { email } })
  }

  static async verifyResetPasswordCode(email: string, code: string): Promise<{ token: string }> {
    const data = await apiRequest<TokenResponse>('user/verify_reset_password_code', {
      method: 'POST',
      body: { email, code },
    })
    return { token: parseToken(data) }
  }

  static resetPassword(email: string, token: string, password: string): Promise<void> {
    return apiRequest('user/reset_password', { method: 'POST', body: { email, token, password } })
  }
}
